import { useProperty, useTranslation } from '@eti/providers';
import { useRef } from 'react';
import ProductLayout from '../../common/main-layout/ProductLayout';
import { useIllustration } from '../../common/utils/useIllustration';
import { SMS } from '../../products';
import { getProduct } from '../../single-choice/utils/singleChoiceTransformer';
import { getPriceProps, getReadMoreLabel, getSingleChoiceProps, getUpsellProps } from '../../common/utils/productCardProps';
import getTranslatedTexts from '../../common/text-resolvers/utils/getTranslatedTexts';
import { useProductSnowplowTracking } from '../../custom-hooks/useProductSnowplowTracking';
import { jsx as _jsx } from "react/jsx-runtime";
const {
  name: PRODUCT_NAME,
  id: PRODUCT_ID
} = SMS;
const texts = {
  additionalInformation: 'smsAdditionalInformation',
  persuasionContent: 'smsPersuasionContent',
  readMoreContent: 'smsReadMoreModalContent',
  description: 'smsAbstract',
  title: 'smsTitle',
  upSell: 'smsUpSellText'
};
const MainSms = _ref => {
  let {
    className,
    form,
    isSelected,
    order,
    productPosition
  } = _ref;
  const {
    t,
    nonDebugT
  } = useTranslation();
  const translation = getTranslatedTexts(texts, t);
  const {
    p
  } = useProperty();
  const illustrationUrl = useIllustration(PRODUCT_NAME);
  const product = getProduct(PRODUCT_ID, order, 'none');
  const rootElement = useRef(null);
  useProductSnowplowTracking(PRODUCT_NAME, {
    productPosition,
    rootElement
  });
  if (!product) {
    return null;
  }
  const {
    priceRaw
  } = product;
  const {
    upSellObject,
    isUpsellHighlight = false,
    shouldDisplayUpsell = false
  } = getUpsellProps(translation.upSell);
  const {
    priceLabel,
    price,
    priceSuffix
  } = getPriceProps(t, isSelected, product);
  const extraProps = getSingleChoiceProps(t, p, nonDebugT);
  const {
    additionalInformation,
    description,
    readMoreContent,
    title
  } = translation;
  const readMoreButtonLabel = getReadMoreLabel(t);
  const productData = {
    additionalInformation,
    className,
    description,
    extraProps,
    form,
    illustrationUrl,
    isHighlighted: isUpsellHighlight,
    isSelected,
    price,
    priceLabel,
    priceRaw,
    priceSuffix,
    productId: PRODUCT_ID,
    productName: PRODUCT_NAME,
    productPosition,
    readMoreButtonLabel,
    readMoreContent,
    shouldDisplayUpsell,
    title,
    travelers: order.travelers,
    upSell: upSellObject
  };
  return /*#__PURE__*/_jsx(ProductLayout, {
    productData: productData,
    ref: rootElement
  });
};
export default MainSms;